export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hardscape-pro-5/artifacts/us8d2lx6_AAA382C8-9E6E-46E0-943C-FE55EB9E926B.png";

export const BRAND_NAME = "M&L Exterior and Interior Design";

export default function Logo({ size = "md", className = "" }) {
  const heights = {
    xs: "h-8",
    sm: "h-10",
    md: "h-14",
    lg: "h-20",
    xl: "h-24",
    xxl: "h-32",
  };
  return (
    <img
      src={LOGO_URL}
      alt="M&L Exterior and Interior Design · Flooring & Home Renovations — Premium LVP, laminate, tile, and pavers in Greater St. Louis"
      data-testid="brand-logo"
      className={`${heights[size]} w-auto object-contain ${className}`}
      loading="eager"
    />
  );
}

// Monogram block — the recurring M&L brand mark used throughout the site
export function Monogram({ inverted = false, size = "md", className = "" }) {
  const sizeMap = {
    sm: "text-lg px-2 py-1",
    md: "text-2xl px-3 py-1.5",
    lg: "text-3xl px-4 py-2",
  };
  return (
    <span
      data-testid="brand-monogram"
      className={`inline-flex items-center font-display leading-none ${
        inverted ? "bg-stone-50 text-stone-900" : "bg-stone-900 text-stone-50"
      } ${sizeMap[size]} ${className}`}
    >
      M
      <span className={inverted ? "text-orange-600 mx-0.5" : "text-orange-500 mx-0.5"}>
        &amp;
      </span>
      L
    </span>
  );
}
